import { generateAppid } from "../hooks/useAppids";

const LOGIN_PAGE = ":login-page";
const LOGIN_MFA_PAGE = ":login:mfa-page";
const LOGIN_UPDATE_PROFILE_PAGE = ":login:update-profile-page";
const ACCOUNT_LOCKED_PAGE = ":account-locked-page";
const DEFAULT_ERROR_PAGE = ":default-error-page";

const FORGOT_USERNAME = ":forgot-username-page";
const FORGOT_USERNAME_SUCCESS = ":forgot-username-page:success";

const PASSWORD_RESET = ":password-reset-page";
const PASSWORD_RESET_MFA = ":password-reset-page:mfa";
const PASSWORD_RESET_SUCCESS = ":password-reset-page:success";

const UPDATE_PROFILE = ':update-profile-page';
const UPDATE_PROFILE_SQA = ':update-profile-page:sqa';
const UPDATE_PROFILE_PASSWORD_RESET = ':update-profile-page:password-reset';

const SITE_TYPE = "cws";
const ERROR_CATEGORY = "login-in-error";
const USER_TYPE = "customer";
const PAGE_TYPE = "transactional";
const CONTENT_TYPE = "application";
const LOB = "us retirement";
const SEGMENT = "gwam";
const COUNTRY = "us";

const siteType = SITE_TYPE;
const errorCategory = ERROR_CATEGORY;

const B2B_EVENT_TYPES = {
  LOGIN_START: "login_start",
  PAGE_LOAD: "page_load",
  LOGIN_ERROR: "login_error",
  LOGIN_COMPLETE: "login_complete",
  LINK_CLICK: "link_click",
};

const b2bEvents = {
  loginStart: B2B_EVENT_TYPES.LOGIN_START,
  pageLoad: B2B_EVENT_TYPES.PAGE_LOAD,
  loginError: B2B_EVENT_TYPES.LOGIN_ERROR,
  loginComplete: B2B_EVENT_TYPES.LOGIN_COMPLETE,
  linkClick: B2B_EVENT_TYPES.LINK_CLICK,
};

const SITE_SECTIONS = {
  FORGOT_USERNAME: 'forgot-username',
  PASSWORD_RESET: 'password-reset',
  UPDATE_PROFILE: 'update-profile'
};

const siteSections = {
  forgotUsername: SITE_SECTIONS.FORGOT_USERNAME,
  passwordReset: SITE_SECTIONS.PASSWORD_RESET,
  updateProfile: SITE_SECTIONS.UPDATE_PROFILE
};

const MFA = "MFA";

//   For Reference
//   window.location.href: 'http://localhost:3000/auth/login?appid=362772';
//   window.location.origin: 'http://localhost:3000';
//   window.location.pathname: '/auth/login';

const enabled = {
  local: true,
  test: true,
  dev: true,
  uat: true,
  prod: true,
};
const disabled = {
  local: false,
  test: false,
  dev: false,
  uat: false,
  prod: false,
};
const activeAdobeAppsObj = {
//   1104: enabled, // rps (myplan)
//   27096999: enabled, // vitality
//   27096405: enabled, // vitality
  1106: enabled, // b2b
  1104: enabled, // b2c
  266981: enabled, // csl
  DEFAULT: disabled, // if appid is not passed
};

const adobeUrlsObj = {
//   1104: process.env.REACT_APP_ADOBE_RPS_URL, // rps
//   27096999: process.env.REACT_APP_ADOBE_VITALITY_URL, // vitality
//   27096405: process.env.REACT_APP_ADOBE_VITALITY_URL, // vitality
  1106: process.env.REACT_APP_ADOBE_USRB2BPORTAL_URL, // USRB2BPortal
  1104: process.env.REACT_APP_ADOBE_USRB2BPORTAL_URL, // USRB2CPortal
  266981: process.env.REACT_APP_ADOBE_PROVIDER_URL, // CSL Provider
  DEFAULT: "",
};

const pageNamesObj = {
//   1104: "RPS",
//   27096999: "insurance:vitality:johnhancockinsurance",
//   27096405: "insurance:vitality:johnhancockinsurance",
  1106: "Swift B2B",
  1104: "USR B2C Participants",
  266981: "provider:csl:johnhancockinsurance",
  DEFAULT: "",
};

const DEFAULT_PAGE_SUBSECTIONS = {
  login: LOGIN_PAGE,
  loginMfa: LOGIN_MFA_PAGE,
  loginUpdateProfile: LOGIN_UPDATE_PROFILE_PAGE,
  accountLocked: ACCOUNT_LOCKED_PAGE,

  forgotUsername: FORGOT_USERNAME,
  forgotUsernameSuccess: FORGOT_USERNAME_SUCCESS,

  passwordReset: PASSWORD_RESET,
  passwordResetMfa: PASSWORD_RESET_MFA,
  passwordResetSuccess: PASSWORD_RESET_SUCCESS,

  updateProfile: UPDATE_PROFILE,
  updateProfileSQA: UPDATE_PROFILE_SQA,
  updateProfilePasswordReset: UPDATE_PROFILE_PASSWORD_RESET,

  defaultError: DEFAULT_ERROR_PAGE,
};

const pageSubSectionNameObj = {
  1106: DEFAULT_PAGE_SUBSECTIONS,
  1104: DEFAULT_PAGE_SUBSECTIONS,
  266981: DEFAULT_PAGE_SUBSECTIONS,
  DEFAULT: {},
};

const handler = {
  get: (objArg, key) => objArg[key] || objArg.DEFAULT,
};

export const adobeActiveApps = new Proxy(activeAdobeAppsObj, handler);
export const adobeUrls = new Proxy(adobeUrlsObj, handler);
export const adobePageNames = new Proxy(pageNamesObj, handler);
export const pageSubSectionName = new Proxy(pageSubSectionNameObj, handler);

/*______________________________*/
/*______________________________*/
/*______________________________*/
// Functions

export const generatePageName = (subPage = "") => {
  const { appid } = generateAppid();
  const pageNameSection1 = adobePageNames[appid] || "";

  const pageNameSection2 = pageSubSectionName[appid][subPage] || "";
  return pageNameSection1 + pageNameSection2;
};

const generateEcid = () => {
  const ECID = window._satellite?.getVisitorId()?.getMarketingCloudVisitorID();
  return ECID;
};

export const geberatePageLoadDl = (subPage, flow) => {
  const title = document.title;
  const language = document.documentElement.lang;
  const ecid = generateEcid();
  console.log("qa testing datalayer", { title, language, ecid });

  return {
    event: b2bEvents.pageLoad,
    page: {
      pageName: generatePageName(subPage), // "<site>:<section>:<sub-section(s)>:<page-name>"
      type: PAGE_TYPE,
      siteType,
      siteSection: siteSections[flow] || '',
      contentType: CONTENT_TYPE,
      brand: "",
      loB: LOB,
      segment: SEGMENT,
      country: COUNTRY,
      region: "",
      city: "",
      title,
      pageURL: window.location.href,
      userAgent: window.navigator.userAgent,
      botDetector: window.navigator.webdriver,
      language,
      platform: "",
      previousPage: document.referrer,
      pageNavPosition: "", // need confirmation from Kajal
    },
    user: {
      anonymousID: ecid,
      primaryCustomerID: "",
      secondaryCustomerID: "",
      tertiaryCustomerID: "",
      emailAddress_Hashed: "",
      age: "",
      gender: "",
      spouseAge: "",
      spouseGender: "",
      numberofDependents: "",
      smokingStatus: "",
      type: USER_TYPE,
      subType: "",
      medalliaUUID: "",
      policyIds: "",
      transactions: "",
      assetLevel: "",
      userNavHistory: window.location.href,
    },
  };
};

export const generateErrorEventDl = (
  errorType,
  errorCode,
  errorDescription
) => {
  const error = {
    errorCode, // Standard errorCode
    errorType, // front-validation, backend: Do you have other types of errors?
    errorDescription, // error message detail
    errorCategory, // error Category
  };

  return {
    event: b2bEvents.loginError,
    login: {
      method: MFA, // Method of the login
    },
    error,
  };
};

export const generateLinkClickDl = (linkName, linkHref) => {
  return {
    event: b2bEvents.linkClick,
    click: {
      linkName, // Name of the Link
      linkHref, // Href/URL of the Link
    },
  };
};
